import { useNavigate } from 'react-router';
import { GridColDef, GridRowParams } from '@mui/x-data-grid';

import {
    DataGrid,
    DataGridCard,
    dataGridNestedObjectValueGetter,
} from '@barboxx/admin-components';
import { ID_WIDTH, NAME_MIN_WIDTH } from '@barboxx/admin-utils';
import { Product } from '@barboxx/models';

const columns: GridColDef<Product.Base>[] = [
    {
        field: 'id',
        headerName: 'Id',
        width: ID_WIDTH,
    },
    {
        field: 'brand.name',
        headerName: 'Brand',
        minWidth: NAME_MIN_WIDTH,
        valueGetter: dataGridNestedObjectValueGetter,
    },
    {
        field: 'name',
        headerName: 'Name',
        minWidth: NAME_MIN_WIDTH,
        flex: 1,
    },
    {
        field: 'description',
        headerName: 'Description',
        minWidth: NAME_MIN_WIDTH,
        flex: 2,
    },
    {
        field: 'isAlcoholic',
        headerName: 'Is Alcoholic',
        width: 200,
        type: 'boolean',
    },
];

interface Props {
    products: Product[];
    refetch: () => void;
}

export const ProductListCard = ({ products, refetch }: Props) => {
    const navigate = useNavigate();

    const handleRowClick = (params: GridRowParams) => {
        navigate(`/products/${params.id}`);
    };

    return (
        <DataGridCard title="Products List">
            <DataGrid
                columns={columns}
                disableColumnMenu
                disableRowSelectionOnClick
                paginationMode="client"
                onRowClick={handleRowClick}
                rows={products}
            />
        </DataGridCard>
    );
};
